import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import LogicaAPI from "./logicaapi";
/**
 * Uid2トークンのAPIクラス
 *
 * @extends {LogicaAPI}
 * @constructor
 */

var Uid2 = /*#__PURE__*/function (_LogicaAPI) {
  _inherits(Uid2, _LogicaAPI);

  var _super = _createSuper(Uid2);

  function Uid2() {
    _classCallCheck(this, Uid2);

    return _super.apply(this, arguments);
  }

  _createClass(Uid2, [{
    key: "generate",
    value:
    /**
     * @typedef {Object} Uid2
     * @property {string} advertising_token - ユーザーの暗号化されたAdvertisingToken
     * @property {string} refresh_token - リフレッシュトークン
     * @property {number} identity_expires - AdvertisingTokenの有効期限のタイムスタンプ
     * @property {number} refresh_from - AdvertisingTokenの更新を開始するタイミングを示すタイムスタンプ
     * @property {number} refresh_expires - リフレッシュトークンの有効期限を示すタイムスタンプ
     * @property {string} refresh_response_key - リフレッシュトークンのレスポンスを復号するためのキー
     * @property {string} user_token - 使用しない
     */

    /**
     * @typedef {Object} Uid2Result
     * @property {string} email_hash
     * @property {Uid2} uid2
     */

    /**
     * generate.
     *
     * UID2トークンの生成
     *
     * @return {Primise<Uid2Result>} result
     */
    function () {
      var _generate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.post("/api/v1/uid2/v2_generate"));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function generate() {
        return _generate.apply(this, arguments);
      }

      return generate;
    }()
    /**
     * refresh.
     *
     * UID2トークンのリフレッシュ
     *
     * @param {string} token - リフレッシュトークン
     * @param {string} key - refresh_response_key
     * @param {string} hash - email_hash
     * @return {Promise<Uid2Result>} result
     */

  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(token, key, hash) {
        var params;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  refresh_token: token,
                  refresh_response_key: key,
                  email_hash: hash
                };
                return _context2.abrupt("return", this.post("/api/v1/uid2/v2_refresh", {
                  body: params
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refresh(_x, _x2, _x3) {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }]);

  return Uid2;
}(LogicaAPI);

/**
 * @type {string} STATUS_SUCCESS
 */
_defineProperty(Uid2, "STATUS_SUCCESS", "success");

export default Uid2;